import styled from "styled-components";
import { useState, useEffect, useCallback } from "react";
import Furigana from "../../components/furigana";
import Dialog from "@mui/material/Dialog";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";

// import ToggleButton from "@mui/material/ToggleButton";
// import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

const StyledCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const FakeTextField = styled.div`
  height: 40px;
  border: 1px solid #2a3447;
  border-radius: 24px;
  background-color: #1a2232;
  margin-bottom: 10px;
  position: relative;
  display: flex;
`;

const FakeLabel = styled.div`
  left: 0;
  top: 0;
  color: #94a3b8;
  padding: 0 6px;
  position: absolute;
  display: block;
  transition:
    background 0.2s,
    transform 0.2s;
  transform-origin: top left;
  ${(props) =>
    props.$fill
      ? "background: linear-gradient(to top, #1a223200 25%, #1a2232 25%, #1e2638 50%); transform: translate(9px, -9px) scale(0.75);"
      : "background: none; transform: translate(7px, 7px) scale(1);"}
`;

const FakeContent = styled.div`
  padding: 8.5px 14px;
  display: flex;
  align-self: center;
`;

const FormVocabulary = ({
  selected,
  categories,
  types,
  open,
  setOpen,
  create,
  update,
  remove,
}) => {
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [jlpt, setJlpt] = useState();
  const [category, setCategory] = useState();
  const [type, setType] = useState();
  const [japaneseFurigana, setJapaneseFurigana] = useState("");
  const [japaneseKanji, setJapaneseKanji] = useState("");
  const [kanjiFormList, setKanjiFormList] = useState([]);
  const [french, setFrench] = useState();
  const [detail, setDetail] = useState();
  const [selfid, setSelfid] = useState();
  const [linkid, setLinkid] = useState();

  useEffect(() => {
    setJlpt(selected?.jlpt);
    setCategory(selected?.category);
    setType(selected?.type);
    setJapaneseFurigana(selected?.japanese);
    setFrench(selected?.french);
    setDetail(selected?.detail);
    setSelfid(selected?.selfid);
    setLinkid(selected?.linkid);
  }, [selected]);

  const myLog = useCallback(
    async (caractereList, combineCaractereList) => {
      // var red = "color:red;";
      // var blue = "color:blue;";
      // var background = "background:green;";
      // var large = "font-size:x-large;";
      // console.log("%cHello %cWorld %cfoo %cbar", red, blue + large, red + background, blue);

      console.group("Lists");
      console.log(caractereList[0]);
      console.log(combineCaractereList[0]);
      console.groupEnd();

      console.group("Results");
      console.log(`Kanji: %c${japaneseKanji}`, "color:red");
      console.log(
        `Furigana: %c${japaneseFurigana}`,
        "color:green;font-size:x-large;",
      );
      console.groupEnd();
    },
    [japaneseKanji, japaneseFurigana],
  );

  useEffect(() => {
    const caractereList = [
      /* HIRAGANA — Voyelles et consonnes principales */
      ["あ", "a"],
      ["い", "i"],
      ["う", "u"],
      ["え", "e"],
      ["お", "o"],
      ["か", "ka"],
      ["き", "ki"],
      ["く", "ku"],
      ["け", "ke"],
      ["こ", "ko"],
      ["さ", "sa"],
      ["し", "shi"],
      ["す", "su"],
      ["せ", "se"],
      ["そ", "so"],
      ["た", "ta"],
      ["ち", "chi"],
      ["つ", "tsu"],
      ["て", "te"],
      ["と", "to"],
      ["な", "na"],
      ["に", "ni"],
      ["ぬ", "nu"],
      ["ね", "ne"],
      ["の", "no"],
      ["は", "ha"],
      ["ひ", "hi"],
      ["ふ", "fu"],
      ["へ", "he"],
      ["ほ", "ho"],
      ["ま", "ma"],
      ["み", "mi"],
      ["む", "mu"],
      ["め", "me"],
      ["も", "mo"],
      ["や", "ya"],
      ["ゆ", "yu"],
      ["よ", "yo"],
      ["ら", "ra"],
      ["り", "ri"],
      ["る", "ru"],
      ["れ", "re"],
      ["ろ", "ro"],
      ["わ", "wa"],
      ["を", "wo"],
      ["ん", "n"],

      /* HIRAGANA — Dakuten & Handakuten (Voisés) */
      ["が", "ga"],
      ["ぎ", "gi"],
      ["ぐ", "gu"],
      ["げ", "ge"],
      ["ご", "go"],
      ["ざ", "za"],
      ["じ", "ji"],
      ["ず", "zu"],
      ["ぜ", "ze"],
      ["ぞ", "zo"],
      ["だ", "da"],
      ["ぢ", "ji"],
      ["づ", "zu"],
      ["で", "de"],
      ["ど", "do"],
      ["ば", "ba"],
      ["び", "bi"],
      ["ぶ", "bu"],
      ["べ", "be"],
      ["ぼ", "bo"],
      ["ぱ", "pa"],
      ["ぴ", "pi"],
      ["ぷ", "pu"],
      ["ぺ", "pe"],
      ["ぽ", "po"],

      /* HIRAGANA — Petits caractères (Combinaisons & pauses) */
      ["ぁ", "a"],
      ["ぃ", "i"],
      ["ぅ", "u"],
      ["ぇ", "e"],
      ["ぉ", "o"],
      ["ゃ", "ya"],
      ["ゅ", "yu"],
      ["ょ", "yo"],
      ["っ", "tsu"],
      ["ゎ", "wa"],

      /* KATAKANA — Voyelles et consonnes principales */
      ["ア", "a"],
      ["イ", "i"],
      ["ウ", "u"],
      ["エ", "e"],
      ["オ", "o"],
      ["カ", "ka"],
      ["キ", "ki"],
      ["ク", "ku"],
      ["ケ", "ke"],
      ["コ", "ko"],
      ["サ", "sa"],
      ["シ", "shi"],
      ["ス", "su"],
      ["セ", "se"],
      ["ソ", "so"],
      ["タ", "ta"],
      ["チ", "chi"],
      ["ツ", "tsu"],
      ["テ", "te"],
      ["ト", "to"],
      ["ナ", "na"],
      ["ニ", "ni"],
      ["ヌ", "nu"],
      ["ネ", "ne"],
      ["ノ", "no"],
      ["ハ", "ha"],
      ["ヒ", "hi"],
      ["フ", "fu"],
      ["ヘ", "he"],
      ["ホ", "ho"],
      ["マ", "ma"],
      ["ミ", "mi"],
      ["ム", "mu"],
      ["メ", "me"],
      ["モ", "mo"],
      ["ヤ", "ya"],
      ["ユ", "yu"],
      ["ヨ", "yo"],
      ["ラ", "ra"],
      ["リ", "ri"],
      ["ル", "ru"],
      ["レ", "re"],
      ["ロ", "ro"],
      ["ワ", "wa"],
      ["ヲ", "wo"],
      ["ン", "n"],

      /* KATAKANA — Dakuten & Handakuten (Voisés) */
      ["ガ", "ga"],
      ["ギ", "gi"],
      ["グ", "gu"],
      ["ゲ", "ge"],
      ["ゴ", "go"],
      ["ザ", "za"],
      ["ジ", "ji"],
      ["ズ", "zu"],
      ["ゼ", "ze"],
      ["ゾ", "zo"],
      ["ダ", "da"],
      ["ヂ", "ji"],
      ["ヅ", "zu"],
      ["デ", "de"],
      ["ド", "do"],
      ["バ", "ba"],
      ["ビ", "bi"],
      ["ブ", "bu"],
      ["ベ", "be"],
      ["ボ", "bo"],
      ["パ", "pa"],
      ["ピ", "pi"],
      ["プ", "pu"],
      ["ペ", "pe"],
      ["ポ", "po"],
      ["ヴ", "vu"],

      /* KATAKANA — Petits caractères & extensions modernes */
      ["ァ", "a"],
      ["ィ", "i"],
      ["ゥ", "u"],
      ["ェ", "e"],
      ["ォ", "o"],
      ["ャ", "ya"],
      ["ュ", "yu"],
      ["ョ", "yo"],
      ["ッ", "tsu"],
      ["ヮ", "wa"],
      ["ヵ", "ka"],
      ["ヶ", "ke"],

      /* CARACTÈRES SPÉCIAUX ET PONCTUATION */
      ["ー", "-"],
      ["、", ","],
      ["。", "."],
      ["・", "·"],
      ["「", "“"],
      ["」", "”"],
      ["『", "‘"],
      ["』", "’"],
      ["〜", "~"],
      ["ゝ", "hiragana iteration mark"],
      ["ゞ", "hiragana voiced iteration mark"],
      ["ヽ", "katakana iteration mark"],
      ["ヾ", "katakana voiced iteration mark"],
    ];

    const combineCaractereList = [
      /* HIRAGANA COMBINÉS (Yōon de base) */
      ["きゃ", "kya"],
      ["きゅ", "kyu"],
      ["きょ", "kyo"],
      ["しゃ", "sha"],
      ["しゅ", "shu"],
      ["しょ", "sho"],
      ["ちゃ", "cha"],
      ["ちゅ", "chu"],
      ["ちょ", "cho"],
      ["にゃ", "nya"],
      ["にゅ", "nyu"],
      ["にょ", "nyo"],
      ["ひゃ", "hya"],
      ["ひゅ", "hyu"],
      ["ひょ", "hyo"],
      ["みゃ", "mya"],
      ["みゅ", "myu"],
      ["みょ", "myo"],
      ["りゃ", "rya"],
      ["りゅ", "ryu"],
      ["りょ", "ryo"],

      /* HIRAGANA COMBINÉS (Voisés / Dakuten & Handakuten) */
      ["ぎゃ", "gya"],
      ["ぎゅ", "gyu"],
      ["ぎょ", "gyo"],
      ["じゃ", "ja"],
      ["じゅ", "ju"],
      ["じょ", "jo"],
      ["ぢゃ", "ja"],
      ["ぢゅ", "ju"],
      ["ぢょ", "jo"],
      ["びゃ", "bya"],
      ["びゅ", "byu"],
      ["びょ", "byo"],
      ["ぴゃ", "pya"],
      ["ぴゅ", "pyu"],
      ["ぴょ", "pyo"],

      /* KATAKANA COMBINÉS (Yōon de base) */
      ["キャ", "kya"],
      ["キュ", "kyu"],
      ["キョ", "kyo"],
      ["シャ", "sha"],
      ["シュ", "shu"],
      ["ショ", "sho"],
      ["チャ", "cha"],
      ["チュ", "chu"],
      ["チョ", "cho"],
      ["ニャ", "nya"],
      ["ニュ", "nyu"],
      ["ニョ", "nyo"],
      ["ヒャ", "hya"],
      ["ヒュ", "hyu"],
      ["ヒョ", "hyo"],
      ["ミャ", "mya"],
      ["ミュ", "myu"],
      ["ミョ", "myo"],
      ["リャ", "rya"],
      ["リュ", "ryu"],
      ["リョ", "ryo"],

      /* KATAKANA COMBINÉS (Voisés) */
      ["ギャ", "gya"],
      ["ギュ", "gyu"],
      ["ギョ", "gyo"],
      ["ジャ", "ja"],
      ["ジュ", "ju"],
      ["ジョ", "jo"],
      ["ヂャ", "ja"],
      ["ヂュ", "ju"],
      ["ヂョ", "jo"],
      ["ビャ", "bya"],
      ["ビュ", "byu"],
      ["ビョ", "byo"],
      ["ピャ", "pya"],
      ["ピュ", "pyu"],
      ["ピョ", "pyo"],

      /* KATAKANA EXTENSIONS (Sons étrangers modernes) */
      ["シェ", "she"],
      ["ジェ", "je"],
      ["チェ", "che"],
      ["ティ", "ti"],
      ["ディ", "di"],
      ["デュ", "dyu"],
      ["トゥ", "tu"],
      ["ドゥ", "du"],
      ["ファ", "fa"],
      ["フィ", "fi"],
      ["フェ", "fe"],
      ["フォ", "fo"],
      ["フュ", "fyu"],
      ["ウィ", "wi"],
      ["ウェ", "we"],
      ["ウォ", "wo"],
      ["ヴァ", "va"],
      ["ヴィ", "vi"],
      ["ヴェ", "ve"],
      ["ヴォ", "vo"],
      ["ツァ", "tsa"],
      ["ツィ", "tsi"],
      ["ツェ", "tse"],
      ["ツォ", "tso"],
    ];

    // 世の中は三日見ぬ間の桜かな
    // よ の なか は みっかみ ぬ ま の さくら かな
    // Yo no naka ha mikka minu ma no sakura kana

    var wasKanji = false;
    var lastItem = "";
    const initialValue = [];
    setKanjiFormList(
      japaneseKanji.split("").reduce((accumulator, currentValue) => {
        if (caractereList.find((caractere) => currentValue === caractere[0])) {
          wasKanji = false;
          accumulator.push([currentValue]);
          return accumulator;
        } else {
          if (wasKanji) {
            lastItem = accumulator.pop();
            accumulator.push([
              lastItem[0] + currentValue,
              kanjiFormList[accumulator.length]
                ? kanjiFormList[accumulator.length][1]
                : "",
            ]);
            return accumulator;
          } else {
            wasKanji = true;
            accumulator.push([
              currentValue,
              kanjiFormList[accumulator.length]
                ? kanjiFormList[accumulator.length][1]
                : "",
            ]);
            return accumulator;
          }
        }
      }, initialValue),
    );

    console.group("Format");
    console.log(kanjiFormList);
    console.groupEnd();

    myLog(caractereList, combineCaractereList);
  }, [myLog, japaneseKanji]);

  useEffect(() => {
    setJapaneseFurigana(
      kanjiFormList
        .map((item) => (item.length === 1 ? item : `[${item[0]}=${item[1]}]`))
        .join(""),
    );
  }, [setJapaneseFurigana, kanjiFormList]);

  const action = () => {
    setLoading(true);
    (selected?._id
      ? update(selected._id, {
          ...(jlpt && { jlpt }),
          ...(category && { category }),
          ...(type && { type }),
          ...(japaneseFurigana && { japaneseFurigana }),
          ...(french && { french }),
          ...(detail && { detail }),
          ...(selfid && { selfid }),
          ...(linkid && { linkid }),
        })
      : create({
          ...(jlpt && { jlpt }),
          ...(category && { category }),
          ...(type && { type }),
          ...(japaneseFurigana && { japaneseFurigana }),
          ...(french && { french }),
          ...(detail && { detail }),
          ...(selfid && { selfid }),
          ...(linkid && { linkid }),
        })
    )
      .then(() => setOpen(false))
      .finally(() => setLoading(false));
  };

  const actionRemove = () => {
    setLoading(true);
    remove(selected._id)
      .then(() => {
        setOpen(false);
        setConfirm(false);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <Card sx={{ width: 300 }}>
          <CardContent>
            <FormControl fullWidth>
              <InputLabel>JLPT</InputLabel>
              <Select
                label="JLPT"
                defaultValue={jlpt || 0}
                onChange={(e) => setJlpt(e.target.value)}
                disabled={loading}
                size="small"
                sx={{ marginBottom: "10px" }}
              >
                <MenuItem value={0}>Non indiqué</MenuItem>
                <MenuItem value={5}>N5</MenuItem>
                <MenuItem value={4}>N4</MenuItem>
                <MenuItem value={3}>N3</MenuItem>
                <MenuItem value={2}>N2</MenuItem>
                <MenuItem value={1}>N1</MenuItem>
              </Select>
            </FormControl>
            <Autocomplete
              freeSolo
              options={categories}
              defaultValue={category || []}
              clearIcon={false}
              multiple
              onChange={(event, value) => setCategory(value)}
              renderTags={(value, props) =>
                value.map((option, index) => (
                  <Chip label={option} {...props({ index })} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Catégories"
                  required
                  disabled={loading}
                  // error={type === "number" || type === "minute" || type === "hour" || type === "day" || type === "week" || type === "month" || type === "conjugation"}
                  fullWidth
                  size="small"
                  sx={{ marginBottom: "10px" }}
                />
              )}
            />
            <Autocomplete
              freeSolo
              options={types}
              defaultValue={type}
              onInputChange={(event, value) => setType(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Type"
                  required
                  disabled={loading}
                  error={
                    type === "number" ||
                    type === "minute" ||
                    type === "hour" ||
                    type === "day" ||
                    type === "week" ||
                    type === "month" ||
                    type === "conjugation"
                  }
                  fullWidth
                  size="small"
                  sx={{ marginBottom: "10px" }}
                />
              )}
            />
            <TextField
              label="Japonais"
              defaultValue={japaneseKanji}
              onChange={(e) => setJapaneseKanji(e.target.value)}
              required
              disabled={loading}
              fullWidth
              size="small"
              sx={{ marginBottom: "10px" }}
            />
            {kanjiFormList.map(
              (elem, index) =>
                elem.length === 2 && (
                  <TextField
                    key={`field${index}`}
                    label={elem[0]}
                    defaultValue={elem[1]}
                    onChange={(e) =>
                      setKanjiFormList((list) =>
                        list.map((item, id) =>
                          id === index ? [item[0], e.target.value] : item,
                        ),
                      )
                    }
                    required
                    disabled={loading}
                    fullWidth
                    size="small"
                    sx={{ marginBottom: "10px" }}
                  />
                ),
            )}
            <FakeTextField>
              <FakeLabel $fill={!!japaneseFurigana}>Furigana *</FakeLabel>
              <FakeContent>
                {japaneseFurigana && (
                  <Furigana center text={japaneseFurigana} small />
                )}
              </FakeContent>
            </FakeTextField>

            <TextField
              label="Français"
              defaultValue={french}
              onChange={(e) => setFrench(e.target.value)}
              required
              disabled={loading}
              fullWidth
              size="small"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Detail"
              defaultValue={detail}
              onChange={(e) => setDetail(e.target.value)}
              disabled={loading}
              fullWidth
              size="small"
              sx={{ marginBottom: "10px" }}
            />
            <TextField
              label="Identifiant"
              defaultValue={selfid}
              onChange={(e) => setSelfid(e.target.value)}
              required
              disabled={loading}
              fullWidth
              size="small"
              sx={{ marginBottom: "10px" }}
            />
            <Autocomplete
              freeSolo
              options={[]}
              defaultValue={linkid || []}
              clearIcon={false}
              multiple
              onChange={(event, value) => setLinkid(value)}
              renderTags={(value, props) =>
                value.map((option, index) => (
                  <Chip label={option} {...props({ index })} />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Liens"
                  disabled={loading}
                  // error={type === "number" || type === "minute" || type === "hour" || type === "day" || type === "week" || type === "month" || type === "conjugation"}
                  fullWidth
                  size="small"
                  sx={{ marginBottom: "10px" }}
                />
              )}
            />
          </CardContent>
          <CardActions sx={{ display: "flex", justifyContent: "space-evenly" }}>
            {selected?._id && (
              <Button
                variant="outlined"
                color="error"
                onClick={() => setConfirm(true)}
                disabled={loading}
                size="small"
              >
                Supprimer
              </Button>
            )}
            <Button
              variant="outlined"
              color="success"
              onClick={() => action()}
              disabled={
                loading ||
                !category ||
                !type ||
                !japaneseFurigana ||
                !french ||
                !selfid ||
                type === "number" ||
                type === "minute" ||
                type === "hour" ||
                type === "day" ||
                type === "week" ||
                type === "month" ||
                type === "conjugation"
              }
              size="small"
            >
              {selected?._id ? "Modifier" : "Créer"}
            </Button>
          </CardActions>
        </Card>
      </Dialog>
      <Dialog open={confirm} onClose={() => setConfirm(false)}>
        <Card>
          <StyledCardContent>
            <Typography variant="body1">
              Êtes-vous sûr de vouloir supprimer:
            </Typography>
            <Typography variant="subtitle1">{french}</Typography>
            <Furigana center text={japaneseFurigana} />
          </StyledCardContent>
          <CardActions sx={{ display: "flex", justifyContent: "space-evenly" }}>
            <Button
              variant="outlined"
              color="success"
              onClick={() => setConfirm(false)}
              disabled={loading}
              size="small"
            >
              Annuler
            </Button>

            <Button
              variant="outlined"
              color="error"
              onClick={() => actionRemove()}
              disabled={loading}
              size="small"
            >
              Supprimer
            </Button>
          </CardActions>
        </Card>
      </Dialog>
    </>
  );
};

export default FormVocabulary;
